<style lang="less">
    @import './styles/menu.less';
</style>

<style lang="less" scoped>
    .sidebar-menu-title{
        padding-right: 24px;
    }
    .shrink-title{
        padding-right: 0;
    }
    .tenantTitle{
        max-width: 165px;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
</style>

<template>
    <div :style="{background: bgColor}" class="ivu-shrinkable-menu">
        <slot name="top"></slot>
        <div :class="'sidebar-menu-title' + (shrink?' shrink-title':'')">
            <!-- 放图标的地方 更改-->
            <!-- <theme-switch></theme-switch> -->
            <!-- <div class="verticalBar"></div> -->
         <!--    <full-screen v-model.trim="isFullScreen" @on-change="fullscreenChange"></full-screen>
            <message-tip v-model.trim="mesCount"></message-tip>
            <lock-screen></lock-screen> -->
            <span class="tenantTitle">
                {{shrink?"菜单": tenantName }}
            </span>
        </div>
        <div class="sidebar-menu-box" v-show="!shrink">
        <sidebar-menu
            v-show="!shrink"
            :menu-theme="theme"
            :menu-list="menuList"
            :open-names="openNames"
            @on-change="handleChange"
        ></sidebar-menu>
        </div>
        <sidebar-menu-shrink
            v-show="shrink"
            :menu-theme="theme"
            :menu-list="menuList"
            :icon-color="shrinkIconColor"
            @on-change="handleChange"
        ></sidebar-menu-shrink>
    </div>
</template>

<script>

import sidebarMenu from './components/sidebarMenu.vue';
import sidebarMenuShrink from './components/sidebarMenuShrink.vue';
import fullScreen from '../fullscreen.vue';
import lockScreen from '../lockscreen/lockscreen.vue';
import messageTip from '../message-tip.vue';
// import themeSwitch from '../theme-switch/theme-switch.vue';
import util from '@/libs/util';
export default {
    name: 'shrinkableMenu',
    data () {
        return {
            isFullScreen: false,
        };
    },
    components: {
        sidebarMenu,
        sidebarMenuShrink,
        fullScreen,
        lockScreen,
        messageTip,
        // themeSwitch
    },
    props: {
        shrink: {
            type: Boolean,
            default: false
        },
        menuList: {
            type: Array,
            required: true
        },
        theme: {
            type: String,
            default: 'light',
            validator (val) {
                return util.oneOf(val, ['dark', 'light']);
            }
        },
        beforePush: {
            type: Function
        },
        openNames: {
            type: Array
        },
        tenantName:{
            type: String,
            default :"无纸化会议后台管理系统"
        }
    },
    computed: {
        bgColor () {
            return this.theme === 'dark' ? '#495060' : '#fff';
        },
        shrinkIconColor () {
            return this.theme === 'dark' ? '#fff' : '#495060';
        },
        mesCount () {
            return this.$store.state.app.messageCount;
        }
    },
    methods: {
        handleChange (name) {
            let willpush = true;
            if (this.beforePush !== undefined) {
                if (!this.beforePush(name)) {
                    willpush = false;
                }
            }
            if (willpush) {
                this.$router.push({
                    name: name
                });
            }
            this.$emit('on-change', name);
        },
        fullscreenChange (isFullScreen) {
            // //console.log(isFullScreen);
        }
    },
    mounted(){
        
    },
};
</script>



// WEBPACK FOOTER //
// src/views/main-components/shrinkable-menu/shrinkable-menu.vue